module.exports = __webpack_public_path__ + "static/img/10.387c037.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/10.png
// module id = rhId
// module chunks = 13